/**
 * Custom organization roles cannot use the reserved Account Owner name.
 * Match is case-insensitive and ignores spaces (e.g. "Account Owner", "accountowner").
 */
export function nameMatchesReservedAccountOwner(name) {
  return String(name ?? '')
    .toLowerCase()
    .replace(/ +/g, '')
    .includes('accountowner')
}

/**
 * System Scanner organization role (check-in accounts). Hidden from role management UI.
 */
export function nameMatchesScannerOrganizationRole(name) {
  return (
    String(name ?? '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '') === 'scanner'
  )
}

/** Roles that should not appear in lists, dropdowns, or edit/delete actions. */
export function nameMatchesHiddenOrganizationRole(name) {
  return nameMatchesScannerOrganizationRole(name)
}

/** Team members with hidden system roles (e.g. Scanner check-in accounts). */
export function filterVisibleTeamMembers(members) {
  if (!Array.isArray(members)) return []
  return members.filter(
    (member) => !nameMatchesHiddenOrganizationRole(member?.role?.name)
  )
}

/**
 * Puts reserved Account Owner names first (same rule as {@link nameMatchesReservedAccountOwner});
 * preserves relative order of all other roles.
 * @param {Array<{ id?: unknown, name?: string }>} roles
 */
export function sortRolesAccountOwnerFirst(roles) {
  if (!Array.isArray(roles)) return []
  return [...roles].sort((a, b) => {
    const aOwner = nameMatchesReservedAccountOwner(a?.name)
    const bOwner = nameMatchesReservedAccountOwner(b?.name)
    if (aOwner !== bOwner) return aOwner ? -1 : 1
    return 0
  })
}
